import { t } from 'i18next';
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import IngredientInput from '../../Framework/Components/Form/IngredientInput';
import style from '../../../scss/components/buttons/button.module.scss';
import { MessageContext } from '../../Framework/Context/MessageContext';

const IngredientToAliasConverter = (props) => {
    const { service, resource } = props;
    const { pushMessage } = useContext(MessageContext);
    const navigate = useNavigate();
    const urlParams = useParams();

    const [ingredientEntity, setIngredientEntity] = useState({});

    const requestId = urlParams.id;
    const ingredientId = ingredientEntity.ingredients?.at(0)?.id;
    const isConvertButtonVisible = Boolean(ingredientId && requestId);

    const convertToAlias = async () => {
        await service
            .post(resource, `${requestId}/convert-to-alias/${ingredientId}`)
            .then((response) => {
                pushMessage({ title: response.message, type: 'success' });
                setTimeout(() => navigate(`/${resource}`), 1000);
            })
            .catch((error) => {
                const body = error?.response?.data;
                pushMessage({ title: body.error, type: 'error' });
            });
    };

    return (
        <div className="mt-6 border-2 border-red p-6">
            <label
                htmlFor="ingredient-input"
                className="text-red text-2xl font-bold block mb-3"
            >
                {t('application.convert_ingredient_change_request_to_alias')}
            </label>
            <IngredientInput
                name="ingredients"
                entity={ingredientEntity}
                resource="ingredients"
                onChange={(entity) => setIngredientEntity(entity)}
                service={service}
            />
            <button
                type="button"
                className={`${style.button} ${style.basic} mt-3`}
                onClick={convertToAlias}
                disabled={!isConvertButtonVisible}
            >
                Click to convert
            </button>
        </div>
    );
};

export default IngredientToAliasConverter;

IngredientToAliasConverter.propTypes = {
    service: PropTypes.object.isRequired,
    resource: PropTypes.oneOf(['ingredient-change-requests', 'ingredients'])
        .isRequired,
};
